<template>
  <client-only>
    <!-- Google Tag Manager (noscript) -->
    <noscript>
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-54DCTNB3" height="0" width="0"
        style="display:none;visibility:hidden"></iframe>
    </noscript>
    <!-- End Google Tag Manager (noscript) -->
  </client-only>

  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <RaychatWidget :widget-id="config.public.raychatWidgetId" />
</template>

<script setup lang="ts">
import { initAttribution } from '@payjib/shared'
import { onMounted } from 'vue'
import RaychatWidget from './components/shared/Raychat.vue'
import { AUTH_PERSISTENT_KEYS } from './constants/auth-persistent.constant'

const config = useRuntimeConfig()

onMounted(() => {
  const token = useCookie(AUTH_PERSISTENT_KEYS.TOKEN).value
  if (!token) return
  initAttribution(`${config.public.apiBase}/v2/attribution`, token)
})
// Toast is handled via the composable; AppToast renders it globally
</script>
